import { api } from './_client';
import type {
  AgentSummary,
  CycleLogEntry,
  EcosystemKPIs,
  EcosystemOpenIssue,
  AgentPR,
  EmailThread,
  FindingsDoc,
  FindingsDocContent,
  LoopConfig,
  StateMdResponse,
} from '../../types/agents';

export const agentsApi = {
  async checkAgentsAccess(): Promise<{ has_access: boolean }> {
    const response = await api.get<{ has_access: boolean }>('/api/agents/access');
    return response.data;
  },

  async getAgentsOverview(): Promise<EcosystemKPIs> {
    const response = await api.get<EcosystemKPIs>('/api/agents/overview');
    return response.data;
  },

  async getAgentsList(): Promise<AgentSummary[]> {
    const response = await api.get<AgentSummary[]>('/api/agents/list');
    return response.data;
  },

  async getAgentCycleLog(name: string, limit = 50): Promise<CycleLogEntry[]> {
    const response = await api.get<CycleLogEntry[]>(
      `/api/agents/${encodeURIComponent(name)}/cycle-log`,
      { params: { limit } }
    );
    return response.data;
  },

  async getAgentFindings(name: string): Promise<FindingsDoc[]> {
    const response = await api.get<FindingsDoc[]>(
      `/api/agents/${encodeURIComponent(name)}/findings`
    );
    return response.data;
  },

  async getFindingsDoc(filename: string): Promise<FindingsDocContent> {
    const response = await api.get<FindingsDocContent>(
      `/api/agents/findings/${encodeURIComponent(filename)}`
    );
    return response.data;
  },

  async getAgentsOpenIssues(): Promise<EcosystemOpenIssue[]> {
    const response = await api.get<EcosystemOpenIssue[]>('/api/agents/issues');
    return response.data;
  },

  async getAgentsRecentPRs(limit = 20): Promise<AgentPR[]> {
    const response = await api.get<AgentPR[]>('/api/agents/prs/recent', {
      params: { limit },
    });
    return response.data;
  },

  async getAgentsRecentEmails(limit = 10): Promise<EmailThread[]> {
    const response = await api.get<EmailThread[]>('/api/agents/emails/recent', {
      params: { limit },
    });
    return response.data;
  },

  async getAgentsStateMd(): Promise<StateMdResponse> {
    const response = await api.get<StateMdResponse>('/api/agents/state-md');
    return response.data;
  },

  async getAgentsConfig(): Promise<LoopConfig> {
    const response = await api.get<LoopConfig>('/api/agents/config');
    return response.data;
  },
};
